let helper = {};
var len, str, chr, index$1, expressionPos, expressionEndPos;
helper.parseModel = function (val) {
  val = val.trim();
  len = val.length;

  if (val.indexOf("[") < 0 || val.lastIndexOf("]") < len - 1) {
    index$1 = val.lastIndexOf(".");
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      };
    } else {
      return {
        exp: val,
        key: null
      };
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5b) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  };
};

// helper.getVueComponentByElement = function (el, cb) {
//   let arr = [];
//   let vue = el?.__vue__ || null;
//   if (vue) {
//     arr.push(vue);
//   }
//   if (vue) {
//     let vnode = vue._vnode;
//     let instance = vnode ? vnode.componentInstance : null;
//     instance && arr.push(instance);
//   }
//   if (cb) {
//     arr = _.filter(arr, (it) => {
//       return cb(it);
//     });
//   }
//   if (arr.length == 1) {
//     return arr[0];
//   }
//   return arr;
// };

function next() {
  return str.charCodeAt(++index$1);
}

function eof() {
  return index$1 >= len;
}

function isStringStart(chr) {
  return chr === 0x22 || chr === 0x27;
}

function parseBracket(chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue;
    }
    if (chr === 0x5b) {
      inBracket++;
    }
    if (chr === 0x5d) {
      inBracket--;
    }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break;
    }
  }
}

function parseString(chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break;
    }
  }
}

export default helper;
